import React, { useEffect, useMemo, useRef } from 'react';

import { area } from 'd3-shape';
import { select } from 'd3-selection';

import COLORS from '../../../../constants/colors.constants';

import { getCurveFunctionFromType } from '../d3-helpers';

const Area = ({
  xScale, 
  yScale, 
  data, 
  curve,
  opacity = 0.5,
  id = 'area',
  fill = COLORS.border.dark,
}) => {
  const areaRef = useRef();
  const areaFunc = useMemo(() => area()
    .x(d => xScale(d.x))
    .y0(yScale(0))
    .y1(d => yScale(d.y))
    .curve(getCurveFunctionFromType(curve)), [curve, xScale, yScale])

  useEffect(() => {
    // Add the area
    select(areaRef.current)
      .datum(data)
      .attr('d', areaFunc)
      .exit()
      .remove()
  }, [areaFunc, data])

  return <path
    id={id}
    className="area"
    ref={areaRef}
    fill={fill}
    stroke="none"
    opacity={opacity}
  />;
}

export default Area;
